"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SDTFItemData_typeHint, _SDTFItemData_value, _SDTFItemData_attributes;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDTFItemData = void 0;
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
class SDTFItemData extends viewer_shared_node_tree_1.AbstractTreeNodeData {
    // #endregion Properties (3)
    // #region Constructors (1)
    constructor(typeHint, value, attributes, id) {
        super(id);
        // #region Properties (3)
        _SDTFItemData_typeHint.set(this, void 0);
        _SDTFItemData_value.set(this, void 0);
        _SDTFItemData_attributes.set(this, {});
        __classPrivateFieldSet(this, _SDTFItemData_attributes, attributes, "f");
        __classPrivateFieldSet(this, _SDTFItemData_typeHint, typeHint, "f");
        __classPrivateFieldSet(this, _SDTFItemData_value, value, "f");
    }
    // #endregion Constructors (1)
    // #region Public Accessors (3)
    get attributes() {
        return __classPrivateFieldGet(this, _SDTFItemData_attributes, "f");
    }
    get typeHint() {
        return __classPrivateFieldGet(this, _SDTFItemData_typeHint, "f");
    }
    get value() {
        return __classPrivateFieldGet(this, _SDTFItemData_value, "f");
    }
    // #endregion Public Accessors (3)
    // #region Public Methods (1)
    /**
     * Clones the scene graph data.
     */
    clone() {
        return new SDTFItemData(this.typeHint, this.value, this.attributes, this.id);
    }
}
exports.SDTFItemData = SDTFItemData;
_SDTFItemData_typeHint = new WeakMap(), _SDTFItemData_value = new WeakMap(), _SDTFItemData_attributes = new WeakMap();
//# sourceMappingURL=SDTFItemData.js.map